import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; // CLI imports router
import { ReceiptUploadPage } from 'src/app/doc2txt/receipt/upload/receiptUploadPage';
import { ExtrTblUploadPage } from 'src/app/doc2txt/extrTbl/upload/extrTblUploadPage';
import { AboutUsPageComponent } from 'src/app/doc2txt/pages/about-us-page/about-us-page.component';
import { PricesComponent } from 'src/app/doc2txt/pages/prices/prices.component';
import { StatsComponent } from 'src/app/doc2txt/pages/stats/stats.component';
import { ApiDocComponent } from 'src/app/doc2txt/pages/api-doc/api-doc.component';
import { TokensComponent } from './tokens/tokens.component';
import { WeedexPageComponent } from './doc2txt/weedex-page/weedex-page.component';
import { PassportPageComponent } from './doc2txt/passport-page/passport-page.component';
import { BarcodePageComponent } from './doc2txt/barcode-page/barcode-page.component';
import { TokenDetailsPageComponent } from './tokens/token-details-page/token-details-page.component';
import { UserPageComponent } from './user/user-page/user-page.component';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { AuthComponent } from './auth/auth.component';
import { UnauthGuard } from './auth/unauth.guard';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { ConfirmCodeComponent } from './auth/confirm-code/confirm-code.component';
import { ProfileComponent } from './auth/profile/profile.component';
import { AuthGuard } from './auth/auth.guard';
import { SumitPaymentPageComponent } from './user/sumit-payment-page/sumit-payment-page.component';
import { OcrPlusUploadComponent } from './doc2txt/ocrPlus/ocr-plus-upload/ocr-plus-upload.component';
import { ResumePageComponent } from './doc2txt/resume-page/resume-page.component';
import { SihachUploadPageComponent } from './doc2txt/sihach/upload/sihach-upload-page.component';
import { OcrCvTblUploadComponent } from './doc2txt/ocrCvTbl/ocr-cv-tbl-upload/ocr-cv-tbl-upload.component';
import { OcrPlusInvoiceComponent } from './doc2txt/ocr-plus-invoice/ocr-plus-invoice.component';

const routes: Routes = [
  { path: 'apiDoc', component: ApiDocComponent },
  { path: 'stats', component: StatsComponent },
  { path: 'prices', component: PricesComponent },
  { path: 'aboutUs', component: AboutUsPageComponent },
  { path: 'receiptPage', component: ReceiptUploadPage },
  { path: 'adminTokens', component: TokensComponent },
  { path: 'extrTblPage', component: ExtrTblUploadPage },
  { path: 'ocrTable', component: OcrCvTblUploadComponent },
  { path: 'ocrPlus', component: OcrPlusUploadComponent },
  { path: 'weedexPage', component: WeedexPageComponent },
  { path: 'passportPage', component: PassportPageComponent },
  { path: 'resumePage', component: ResumePageComponent },
  { path: 'tokenDetails', component: TokenDetailsPageComponent },
  { path: 'barcodePage', component: BarcodePageComponent },
  { path: 'user', component: UserPageComponent },
  { path: 'sumitPayment', component: SumitPaymentPageComponent },
  { path: 'sihach', component: SihachUploadPageComponent },
  { path: 'ocrPlusInvoice', component: OcrPlusInvoiceComponent },

  // { path: '', redirectTo: '/ocrTable', pathMatch: 'full' }, // redirect to `receipt`
  { path: '', redirectTo: '/ocrPlus', pathMatch: 'full' }, // redirect to `receipt`

  {
    path: 'auth',
    component: AuthComponent,
    children: [
      {
        path: 'signin',
        component: SignInComponent,
        canActivate: [UnauthGuard],
      },
      {
        path: 'signup',
        component: SignUpComponent,
        canActivate: [UnauthGuard],
      },
      {
        path: 'confirm',
        component: ConfirmCodeComponent,
        canActivate: [UnauthGuard],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];
// configures NgModule imports and exports
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
